module.exports = __webpack_public_path__ + "static/media/reviewed.6bedc510.svg";